export default "__VITE_PUBLIC_ASSET__5773bb3a__"